// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"354":"0c53c7f1","455":"e021a6ef","488":"1a9a8f8c","614":"1e9d4ab3","685":"729ef1fc","695":"6ddd2c79","977":"a3022c91"}[chunkId] + ".chunk.js";
};